import { createSelector } from "reselect";
import { ListFieldsKeys } from "src/api/config";
import { JustUpdatedItem } from "src/modules/modules.type";
import { RootState } from "src/store/rootReducer";

const getJustUpdatedItem = (state: RootState, listName: ListFieldsKeys): JustUpdatedItem => {
    return state.spitems.justUpdated[listName] || 0;
};

export const selectJustUpdatedItem = createSelector([getJustUpdatedItem], (id) => {
    return id;
});
